import { makeObservable, observable, runInAction } from 'mobx';
import {
  Contract,
  ContractData,
  ContractStatus,
  ContractType,
} from '@monorepo/types';
import { getEnv, getRoot } from '@hub/helpers/getters.store';

export class ContractStore {
  @observable
  contracts: Contract[] = [];

  constructor() {
    makeObservable(this);
  }

  contractSignNeeded(contractType: ContractType) {
    try {
      const {
        dataStore: { applicationConfigStore },
      } = getRoot();

      const applicationContract = (
        applicationConfigStore.applicationConfig.contracts || []
      ).find((contract) => contract.type === contractType);

      if (!applicationContract) {
        return false;
      }

      const userCurrentContract = this.contracts.find(
        (contract) =>
          contractType === contract.type &&
          applicationContract.currentVersion === contract.version,
      );

      return (
        !userCurrentContract ||
        userCurrentContract.status !== ContractStatus.Signed
      );
    } catch (e) {
      console.error(
        `failed checking if user need to sign contract with error:`,
        e,
      );
    }
  }

  async getUserContracts(): Promise<void> {
    try {
      const {
        apiFactory: { contractService },
      } = getEnv();

      const contracts = await contractService.getUserContracts();
      runInAction(() => {
        this.contracts = contracts;
      });
    } catch (e) {
      console.error(e);
    }
  }

  async signUserContract(
    contractType: ContractType,
    contractData?: ContractData,
  ) {
    try {
      const {
        apiFactory: { contractService },
      } = getEnv();
      await contractService.signUserContract({ contractType, contractData });
      await this.getUserContracts();
    } catch (e) {
      console.error(
        `failed checking if user need to sign contract with error:`,
        e,
      );
    }
  }
}
